import React from 'react';

export const InitialIcon = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.59961 6C5.59961 4.34315 6.94276 3 8.59961 3C10.2565 3 11.5996 4.34315 11.5996 6V7H5.59961V6Z"
      stroke="#B5B8BA"
      strokeWidth="2"
    />
    <rect x="3.59961" y="6" width="10" height="8" rx="1" fill="#B5B8BA" />
  </svg>
);

export const CurrentIcon = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <rect x="0.599609" width="16" height="16" rx="8" fill="#0090FF" />
      <path
        d="M11.13 8.60921C11.5556 8.31437 11.5556 7.6852 11.13 7.39036L7.61283 4.95357C7.12114 4.61291 6.44922 4.96482 6.44922 5.56299L6.44922 10.4366C6.44922 11.0348 7.12114 11.3867 7.61283 11.046L11.13 8.60921Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" transform="translate(0.599609)" />
      </clipPath>
    </defs>
  </svg>
);

export const DoneIcon = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <rect x="0.800781" width="16" height="16" rx="8" fill="#68B76C" />
      <path
        d="M12.1503 6.95711C12.5408 6.56658 12.5408 5.93342 12.1503 5.54289C11.7597 5.15237 11.1266 5.15237 10.7361 5.54289L7.94322 8.33573L6.85757 7.33579C6.46705 6.94526 5.83388 6.94526 5.44336 7.33579C5.05284 7.72631 5.05284 8.35948 5.44336 8.75L7.23612 10.457C7.62664 10.8476 8.2598 10.8476 8.65033 10.457L12.1503 6.95711Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" transform="translate(0.800781)" />
      </clipPath>
    </defs>
  </svg>
);

export const DeniedIcon = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <rect x="0.800781" width="16" height="16" rx="8" fill="#D02931" />
      <path
        d="M11.8717 4.75774C11.4812 4.36721 10.848 4.36721 10.4575 4.75774L8.67199 6.54323L6.92199 4.79323C6.53147 4.40271 5.8983 4.40271 5.50778 4.79323C5.11725 5.18375 5.11725 5.81692 5.50778 6.20744L7.25778 7.95744L5.50774 9.70748C5.11721 10.098 5.11721 10.7312 5.50774 11.1217C5.89826 11.5122 6.53143 11.5122 6.92195 11.1217L8.67199 9.37166L10.4575 11.1572C10.848 11.5477 11.4812 11.5477 11.8717 11.1572C12.2623 10.7667 12.2623 10.1335 11.8717 9.74298L10.0862 7.95744L11.8717 6.17195C12.2622 5.78143 12.2622 5.14826 11.8717 4.75774Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" transform="translate(0.800781)" />
      </clipPath>
    </defs>
  </svg>
);

export const WaiverIcon = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <rect x="0.800781" width="16" height="16" rx="8" fill="#6139C0" />
      <rect x="6.30078" y="5.5" width="5" height="5" rx="1" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" transform="translate(0.800781)" />
      </clipPath>
    </defs>
  </svg>
);
